// src/types/report.ts
export interface ReportPagination {
  current_page: number;
  last_page: number;
  per_page: number;
  from: number;
  to: number;
  total: number;
}

export interface ReportTypeSummary {
  fake_dealer: number;
  fake_car: number;
  mistake_dealer: number;
  customer_report: number;
}

export interface StatusSummary {
  total: number;
}

export interface ReportSummary {
  report_type_summary: ReportTypeSummary;
  status_summary: StatusSummary;
}

export interface Report {
  id?: number;
  customer_id?: number;
  dealer_id?: number;
  schedule_id?: number;
  dealer_name?: string;
  company_name?: string;
  report_type: 'fake_dealer' | 'fake_car' | 'mistake_dealer' | 'customer_report';
  report_description?: string | null;
  notes?: string | null;
  customer_phone?: string | null;
  customer_name?: string | null;
  created_at: string;
}

export interface updateReport {
  id?: number;
  customer_id?: number;
  dealer_id?: number;
  schedule_id?: number;
  dealer_name?: string;
  company_name?: string;
  report_type?: string;
  report_description?: string | null;
  notes?: string | null;
  customer_phone?: string | null;
  customer_name?: string | null;
  created_at?: string;
}

export interface ReportListData {
  list: Report[];
  summary: ReportSummary;
  pagination: ReportPagination;
}

export interface ReportResponse {
  success: boolean;
  data: ReportListData;
  message: string;
}

export interface ReportParams {
  page?: number;
  per_page?: number;
  search?: string;
  report_type?: string;
  dealer_id?: number;
  customer_id?: number;
  customer_name?: string;
  customer_phone?: string;
  report_description?: string;
  end_date?: string;
}

// 신고 타입 라벨 매핑
export const REPORT_TYPE_LABELS: Record<Report['report_type'], string> = {
  fake_dealer: '사실과 다른 차량/딜러 정보',
  fake_car: '정해진 차량이 아닌 다른 차량 유도',
  mistake_dealer: '딜러측 과실로 인한 거래 불가',
  customer_report: '직접 입력',
};

// 신고 타입 짧은 라벨
export const REPORT_TYPE_SHORT_LABELS: Record<Report['report_type'], string> = {
  fake_dealer: '허위정보',
  fake_car: '차량유도',
  mistake_dealer: '딜러과실',
  customer_report: '직접입력',
};

// 신고 타입 색상 매핑
export const REPORT_TYPE_COLORS: Record<Report['report_type'], string> = {
  fake_dealer: 'red',
  fake_car: 'orange',
  mistake_dealer: 'yellow',
  customer_report: 'blue',
};

// 신고 타입 아이콘 (lucide-react)
export const REPORT_TYPE_ICONS: Record<Report['report_type'], string> = {
  fake_dealer: 'AlertTriangle',
  fake_car: 'Car',
  mistake_dealer: 'UserX',
  customer_report: 'FileText',
};
